import React from 'react';
import { Display, Heading, Body, Label } from '../components/Typography';
import VisualSystem from '../components/VisualSystem';

const About = () => {
  return (
    <div className="w-full bg-epoq-paper min-h-screen">
      <section className="py-24 px-6 lg:px-12 max-w-6xl mx-auto">
        <Display className="mb-16 leading-[0.9]">
          Learning should change what an organisation <br />
          <span className="italic text-epoq-coral">can do.</span>
        </Display>
        
        <div className="grid lg:grid-cols-2 gap-16 mt-20">
          <div className="space-y-8 text-xl font-sans opacity-90 leading-relaxed">
            <p>
              EPOQ Learn develops practical learning experiences for organisations facing technological, 
              organisational and strategic change.
            </p>
            <p className="font-medium bg-white p-6 border-l-4 border-epoq-lime shadow-sm">
              We believe professional learning is most valuable when it is connected to real work.
            </p>
            <p>
              That means using relevant cases, practical exercises, clear responsibilities and outcomes 
              that can continue after the programme has ended.
            </p>
          </div>
          <div className="space-y-8 text-lg font-sans opacity-80 leading-relaxed">
            <p>
              Our first learning area is artificial intelligence.
            </p>
            <p>
              Over time, EPOQ Learn may expand into other areas of business transformation, 
              sustainability, leadership, innovation and implementation.
            </p>
          </div>
        </div>
      </section>

      {/* Visual Method Repetition */}
      <section className="py-32 bg-epoq-blue text-epoq-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Label className="text-epoq-lime mb-12 block text-center">The core method</Label>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 text-center font-serif text-3xl md:text-5xl">
            <div className="flex flex-col items-center">
              <VisualSystem stage="understand" className="w-32 h-32 mb-8 bg-transparent shadow-none" />
              <span className="opacity-50 hover:opacity-100 transition-opacity">Understand</span>
            </div>
            <div className="flex flex-col items-center">
              <VisualSystem stage="apply" className="w-32 h-32 mb-8 bg-transparent shadow-none" />
              <span className="opacity-50 hover:opacity-100 transition-opacity">Apply</span>
            </div>
            <div className="flex flex-col items-center">
              <VisualSystem stage="govern" className="w-32 h-32 mb-8 bg-transparent shadow-none" />
              <span className="opacity-50 hover:opacity-100 transition-opacity">Govern</span>
            </div>
            <div className="flex flex-col items-center">
              <VisualSystem stage="implement" className="w-32 h-32 mb-8 bg-transparent shadow-none" />
              <span className="opacity-50 hover:opacity-100 transition-opacity text-epoq-lime">Implement</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;